// Área do vendedor (SPEC-VENDEDORES): CRM interno, propostas e comissões.
export default {
  title: 'Portal do vendedor',
  nav: {
    dashboard: 'Resumo',
    proposals: 'Propostas',
    commissions: 'Comissões',
    clients: 'Clientes',
  },
  dashboard: {
    hello: 'Olá, {name}',
    code: 'Seu código',
    referral_link: 'Seu link de indicação',
    referral_hint: 'Quem se cadastra por ele fica vinculado a você.',
    copy: 'Copiar link',
    copied: 'Link copiado!',
    accrued: 'A receber',
    paid: 'Já pago',
    clients: 'Clientes',
    proposals_open: 'Propostas abertas',
    last_payout: 'Último pagamento',
    no_payout: 'Nenhum pagamento ainda.',
    commission_hint: 'Venda: {sale}% sobre o pedido (sem frete) · Recorrência: {rec}% por {cycles} parcelas.',
    load_failed: 'Não foi possível carregar seu resumo.',
  },
  proposals: {
    title: 'Propostas',
    subtitle: 'Monte o carrinho do cliente e mande o link — o pedido nasce no checkout.',
    new: 'Nova proposta',
    load_failed: 'Não foi possível carregar as propostas.',
    empty: 'Nenhuma proposta ainda.',
    created: 'Proposta criada — copie o link e envie ao cliente.',
    canceled: 'Proposta cancelada.',
    copy: 'Copiar link',
    copied: 'Copiado!',
    cancel: 'Cancelar',
    cancel_confirm: 'Cancelar esta proposta? O link deixa de funcionar.',
    col_customer: 'Cliente',
    col_items: 'Itens',
    col_status: 'Status',
    col_created: 'Criada',
    col_expires: 'Válida até',
    no_customer: 'A definir no checkout',
    items_count: '{count} item(ns)',
    order_link: 'Ver pedido',
    expired_tag: 'expirada',
    status: {
      draft: 'Rascunho',
      sent: 'Enviada',
      converted: 'Convertida',
      canceled: 'Cancelada',
    },
    form: {
      customer_name: 'Nome do cliente',
      customer_email: 'E-mail do cliente',
      customer_phone: 'Telefone do cliente',
      customer_hint: 'Opcional — o cliente pode completar os dados no checkout.',
      items: 'Itens',
      product: 'Produto',
      qty: 'Qtd',
      add_item: '+ Adicionar item',
      select_product: 'Selecione…',
      note: 'Observação (opcional)',
      expires_at: 'Válida até (opcional)',
      submit: 'Criar proposta',
    },
  },
  commissions: {
    title: 'Minhas comissões',
    subtitle: 'Extrato por quinzena — os fechamentos vêm do financeiro.',
    load_failed: 'Não foi possível carregar suas comissões.',
    accrued: 'A receber',
    paid: 'Já pago',
    period_of: 'Quinzena de {date}',
    empty: 'Nenhuma comissão ainda.',
    col_kind: 'Tipo',
    col_order: 'Pedido',
    col_base: 'Base',
    col_pct: '%',
    col_amount: 'Comissão',
    col_state: 'Status',
    kind_sale: 'Venda',
    kind_recurring: 'Recorrência #{n}',
    state_accrued: 'A receber',
    state_paid: 'Pago',
    state_canceled: 'Cancelado',
    payouts_title: 'Pagamentos recebidos',
    payout_row: '{start} → {end}',
    empty_payouts: 'Nenhum pagamento ainda.',
  },
  clients: {
    title: 'Meus clientes',
    subtitle: 'Contas vinculadas ao seu código.',
    load_failed: 'Não foi possível carregar seus clientes.',
    empty: 'Nenhum cliente ainda — compartilhe seu link de indicação.',
    col_client: 'Cliente',
    col_status: 'Status',
    col_orders: 'Pedidos',
    col_subscription: 'Assinatura',
    col_since: 'Cliente desde',
    no_subscription: 'Sem assinatura',
    status_active: 'Ativo',
    status_suspended: 'Suspenso',
    status_canceled: 'Cancelado',
  },
}
